import { gql } from '@apollo/client';
import { ACTIVITY, SESSION, FILE } from '../fragments';

export const GET_ACTIVITY_SESSION = gql`
  query GetActivitySession($id: ID!) {
    activitySession: getActivitySession(id: $id) {
      ...activitySession
      activity {
        renderGroupForm
        ...activity
      }
      files {
        ...file
      }
    }
  }
  ${ACTIVITY}
  ${FILE}
  ${SESSION}
`;
